// extracted by mini-css-extract-plugin
module.exports = {"Aspect16x9":"Blog_Aspect16x9__2mveW","CardImg":"Blog_CardImg__21eRi","inline":"Blog_inline__234v1","unvisibleComment":"Blog_unvisibleComment__1-gka"};